import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import DehazeIcon from "@material-ui/icons/Dehaze";
import { connect } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
import { withRouter } from "react-router";
import HistoryIcon from "@material-ui/icons/History";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import PersonIcon from "@material-ui/icons/Person";

//Actions
import { changeLanguage } from "../../store/actions";
import { ReactComponent as ShoppingCart } from "../ProductDetails/assets/bag.svg";
import MenuIcon from "@material-ui/icons/Menu";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Currency from "../Currency";
import instance from "../../store/actions/instance";
import { saveSearch } from "../../store/actions/store";

class Header extends Component {
  state = {
    showButtons: false,
  };

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({ showButtons: true });
    }, 350);
  };

  searchProducts = async (id) => {
    try {
      const { settings, branch, usedComponents, currency } = this.props;
      let res;
      if (settings.is_branch_based_ordering && (branch.branch || branch.bdc)) {
        res = await instance.post("/search_products_branch_based/000000/", {
          type: branch.isPickup ? "pickup" : "delivery",
          branch_id: branch.branch,
          bdc_id: !branch.isPickup ? branch.bdc : branch.branch,
          used_components: usedComponents,
          country_code: currency.selected,
          specific_product_ids: [id],
          channel: this.props.channel,
        });
      } else {
        res = await instance.post("/search_products/000000/", {
          used_components: usedComponents,
          country_code: currency.selected,
          specific_product_ids: [id],
          channel: this.props.channel,
        });
      }
      if (res.data.products?.length) {
        await this.props.saveSearch(res.data.products);
      }
    } catch (err) {
      console.error(err);
    }
  };
  findProductById = (categoryId, productId) => {
    try {
      const foundCategory = this.props.categories.find(
        (category) => category.id === categoryId
      );
      if (foundCategory) {
        const foundProduct = foundCategory.products.find((product) => {
          return product.id === productId;
        });
        return !foundProduct;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
    }
  };

  handleRedirect = async (item) => {
    const { settings, categories, history } = this.props;
    if (
        settings.show_cover_category &&
        settings.show_cover_category_staff &&
        item?.slug !== null
    ) {
      const foundCategory = categories.find(
          (category) => category.id === item?.category_id
      );

      if (!foundCategory) return;

      const { category_id, product_id } = item;

      if (category_id && product_id) {
        const productExists = this.findProductById(category_id, product_id);
        if (productExists) {
          await this.searchProducts(product_id);
        }

        const product = foundCategory.products.find(
            (product) => product.id === product_id
        );

        if (product) {
          history.push(`/product/${foundCategory.slug}/${product.slug}`);
        }
      } else {
        history.push(`/category/${foundCategory.slug}`);
      }
    }
  };

  render() {
    const { imageSize, store, settings } = this.props;

    const checkForCategoryGallery =
      this.props.settings.show_cover_category &&
      this.props.settings.show_cover_category_staff;

    const autoPlayDelay = store?.settings?.auto_play_delay;

    let images = [
      <div key="Main Photo">
        <img
          src={store.cover_medium || store.cover}
          style={{
            objectFit: "cover",
            height: 300,
          }}
        />
      </div>,
    ];
    const supportedCategories = ["discount-products", "newest", "most-selling"];
    const categoriesImageGallery = this.props.categories
      .filter(
        (obj) =>
          obj.photo !== undefined &&
          obj.photo !== null &&
          obj.show_cover &&
          supportedCategories.includes(obj.id)
      )
      .map((category) => {
        category.category = category.id;
        return category;
      });

    const handleGenerateImage = (gallery) => {
      gallery.forEach((photo) => {
        images.push(
          <div key={photo.id} onClick={() => this.handleRedirect(photo)}>
            <img
              src={photo.photo_medium || photo.photo}
              style={{
                objectFit: "cover",
                height: 300,
              }}
            />
          </div>
        );
      });
    };

    if (store.gallery) {
      handleGenerateImage(
        store.gallery.filter(
          (item) => !(item.is_product_or_category && item.slug === null)
        )
      );
    }

    if (checkForCategoryGallery && categoriesImageGallery) {
      handleGenerateImage(categoriesImageGallery);
    }

    if (imageSize !== "full") {
      return (
        <Carousel
          autoPlay={autoPlayDelay > 0}
          infiniteLoop={images.length > 1}
          showThumbs={false}
          preventMovementUntilSwipeScrollTolerances
          showStatus={false}
          showIndicators={false}
          interval={autoPlayDelay * 1000 || 3000}
        >
          {images}
        </Carousel>
      );
    }

    const hasMenuPages =
      this.props.pages.findIndex((page) => page.placement == 1) != -1;

    return (
      <div>
        {this.state.showButtons && (
          <div>
            {!this.props.isB2B &&
              this.props.store.settings.enable_currency_converter && (
                <Button
                  className={
                    this.props.language == "arabic"
                      ? "currencyButtonLargeScreenArabic header-button-cricle scale-up-center"
                      : "currencyButtonLargeScreenEnglish header-button-cricle scale-up-center"
                  }
                  onClick={() => {
                    //Don't ask why we did this. It fixed a lot of problems.
                    window.scrollBy(0, 1);
                    window.scrollBy(0, -1);
                  }}
                  variant="contained"
                  style={{
                    padding: 0,
                    borderRadius: 20,
                    zIndex: 3,
                    position: "fixed",
                    top: 13,
                    right: 30,
                    minHeight: "40px !important",
                    display: "none",
                    maxWidth: 32,
                  }}
                >
                  <Currency history={this.props.history} />
                </Button>
              )}

            {this.props.store.settings.enable_arabic && (
              <Button
                className={
                  this.props.language == "arabic"
                    ? "languageButtonLargeScreenArabic header-button-cricle scale-up-center"
                    : "languageButtonLargeScreenEnglish header-button-cricle scale-up-center"
                }
                onClick={() => {
                  this.props.changeLanguage();
                  //Don't ask why we did this. It fixed a lot of problems.
                  window.scrollBy(0, 1);
                  window.scrollBy(0, -1);
                }}
                variant="contained"
                style={{
                  padding: 0,
                  borderRadius: 20,
                  zIndex: 3,
                  position: "fixed",
                  top: 13,
                  right: 30,
                  minHeight: "40px !important",
                  display: "none",
                  maxWidth: 32,
                }}
              >
                {this.props.language == "english" ? "ع" : "En"}
              </Button>
            )}
            {!this.props.isB2B && this.props.store.settings.enable_search ? (
              <Button
                className={
                  this.props.language == "arabic"
                    ? "SearchButtonLargeScreenArabic header-button-cricle scale-up-center"
                    : "SearchButtonLargeScreenEnglish header-button-cricle scale-up-center"
                }
                id="search_button"
                onClick={() => {
                  if (window.location.pathname !== "/search")
                    this.props.history.push("/search");
                }}
                variant="contained"
                size="small"
                style={{
                  maxWidth: "32px",
                  minHeight: "30px",
                  zIndex: 3,
                  position: "fixed",
                  top: 13,
                  right: 30,
                  display: "none",
                }}
              >
                <SearchIcon
                  style={{
                    color: "black",
                  }}
                />
              </Button>
            ) : null}
            {!this.props.isB2B && !this.props.store.settings.is_menu && (
              <Button
                className={
                  this.props.language == "english"
                    ? "menuButtonLargeScreenEnglish header-button-cricle scale-up-center"
                    : "menuButtonLargeScreenArabic header-button-cricle scale-up-center"
                }
                onClick={() => {
                  if (
                    (this.props.store.settings.enable_social_auth &&
                      this.props.store.settings.enable_social_auth_staff) ||
                    hasMenuPages
                  ) {
                    if (window.location.pathname !== "/profile") {
                      this.props.history.push("/profile");
                    }
                  } else {
                    if (window.location.pathname !== "/cart") {
                      this.props.history.push("/cart");
                    }
                  }
                }}
                variant="contained"
                size="small"
                style={{
                  maxWidth: "27px",
                  minHeight: "30px",
                  zIndex: 3,
                  position: "fixed",
                  top: 13,
                  display: "none",
                }}
              >
                {(this.props.store.settings.enable_social_auth &&
                  this.props.store.settings.enable_social_auth_staff) ||
                hasMenuPages ? (
                  <MenuIcon />
                ) : (
                  <ShoppingCart />
                )}
              </Button>
            )}
            {(!this.props.isB2B ||
              (this.props.isB2B &&
                this.props.store.settings.enable_tracking)) &&
            !this.props.store.settings.is_menu ? (
              <Button
                className={
                  this.props.language == "english"
                    ? "historyButtonLargeScreenEnglish header-button-cricle scale-up-center"
                    : "historyButtonLargeScreenArabic header-button-cricle scale-up-center"
                }
                onClick={() => {
                  if (
                    ![
                      "/distributor/track/order",
                      "/cart",
                      "/track/previous",
                    ].includes(window.location.pathname)
                  )
                    this.props.history.push(
                      this.props.isB2B
                        ? "/distributor/track/order"
                        : (this.props.store.settings.enable_social_auth &&
                            this.props.store.settings
                              .enable_social_auth_staff) ||
                          hasMenuPages
                        ? "/cart"
                        : "/track/previous"
                    );
                }}
                variant="contained"
                size="small"
                style={{
                  maxWidth: "27px",
                  minHeight: "30px",
                  zIndex: 3,
                  position: "fixed",
                  top: 13,
                  display: "none",
                }}
              >
                {this.props.isB2B ? (
                  <MyLocationIcon />
                ) : (this.props.store.settings.enable_social_auth &&
                    this.props.store.settings.enable_social_auth_staff) ||
                  hasMenuPages ? (
                  <ShoppingCart />
                ) : (
                  <HistoryIcon />
                )}
              </Button>
            ) : null}

            {this.props.isB2B &&
            this.props.store?.settings?.enable_b2b_on_credit_payments &&
            this.props.shouldShowUserButton ? (
              <Button
                className={
                  this.props.language == "english"
                    ? "menuButtonLargeScreenEnglish header-button-cricle scale-up-center"
                    : "menuButtonLargeScreenArabic header-button-cricle scale-up-center"
                }
                onClick={() => {
                  this.props.setB2BProfileOpen(!this.props.b2bProfileOpen);
                }}
                variant="contained"
                size="small"
                style={{
                  maxWidth: "27px",
                  minHeight: "30px",
                  zIndex: 3,
                  position: "fixed",
                  top: 13,
                  display: "none",
                }}
              >
                <PersonIcon />
              </Button>
            ) : null}
          </div>
        )}
        <div
          className="changeToFixedBackground m-0 p-0"
          style={{
            height: imageSize == "full" ? "100%" : "100%",
            width: "100%",
            background:
              this.props.store.cover_medium && this.props.store.cover_large
                ? `-webkit-image-set(url(${this.props.store.cover_medium}) 1x, url(${this.props.store.cover_large}) 2x)`
                : `url(${this.props.store.cover})`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            position: "absolute",
            backgroundSize: "cover",
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    pages: state.staticPages.pages,
    store: state.store.store,
    isB2B: state.store.isB2B,
    b2bProfileOpen: state.b2b.profileOpen,
    shouldShowUserButton: state.b2b.shouldShowUserButton,
    settings: state.store.store.settings,
    categories: state.store.store.categories,
    domain: state.store.store.domain,
    branch: state.branch,
    usedComponents: state.store.used_components,
    currency: state.currency,
    channel: state.promise.src,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeLanguage: () => dispatch(changeLanguage()),
    setB2BProfileOpen: (val) =>
      dispatch({ type: "SET_B2B_PROFILE_OPEN", payload: val }),
    saveSearch: (categories) => dispatch(saveSearch(categories)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
